module.exports = __webpack_public_path__ + "static/image/history/pc/202204@3x.jpg?e630bf78";